import videojs from "@/vendor/videojs/video.es.js";
import {Howl, Howler} from 'howler';

const Plugin = videojs.getPlugin("plugin");

class HiMusic extends Plugin {
  constructor(player, options) {
    super(player, options);
    let that = this;
    this.sound = false;
    this.file = "";
    this.videoEl = player.el().getElementsByTagName("video")[0];
    this.on(player, "attachClip", this.attachClip);
    this.on(player, "stopClip", this.stopClip);

    player.on('loadedmetadata', function() {
      let duration = player.duration();
      that.duration = Math.round(duration);
    });
  }
  stopClip() {
    if (this.sound) {
      this.sound.unload();
    }
  }
  attachClip(e, clip) {
    this.file = clip.filename + "_" + this.duration + "." + clip.format;

    console.log(this.file);

    if (this.sound) {
      this.sound.unload();
    }

    this.sound = false;

    if (!this.player.paused()) {
      this.sound = new Howl({
        src: ['/music/'+this.file]
      });
      this.sound.seek(this.videoEl.currentTime);
      this.sound.play();
    }

    this.videoEl.addEventListener("seeked", this.onSeeked.bind(this));
    this.videoEl.addEventListener("play", this.onPlay.bind(this));
    this.videoEl.addEventListener("pause", this.onPause.bind(this));
  }
  onPlay() {
    if (this.sound == false) {
      this.sound = new Howl({
        src: ['/music/'+this.file]
      });
    }
    this.sound.seek(this.videoEl.currentTime);
    this.sound.play();
  }
  onSeeked() {
    if (this.sound) {
      this.sound.seek(this.videoEl.currentTime);
    }
  }
  onPause() {
    if (this.sound) {
      this.sound.pause();
    }
  }
  dispose() {
    super.dispose();
  }
}

videojs.registerPlugin("HiMusic", HiMusic);
